module.exports = __webpack_public_path__ + "assets/character.a8735b04.svg";